<template lang="pug">
  .program-settings-form-wrapper.is-flex.is-flex-direction-column
    WtTitle(card-title semibold) {{ title }}
      WtTooltip(
        v-if="tooltipText"
        :text="tooltipText"
      )
    BNotification.test(:active.sync="error" type="is-danger" :duration="3000")
      | {{ errorMessage }}
    .is-flex-grow-1
      slot
    ProgramSettingsFormControls.is-flex-grow-0(
      :setting-type="settingType"
      :formKey="formKey"
      v-show="showControls"
      @disable-save="$emit('update:disable-save', true)"
      :disable-save="disableSave"
      :form-data="formData"
      @reset="$emit('reset')",
      :keys-to-reset="keysToReset"
      @form-error="handleFormError($event)"
      :disableReset="disableReset"
      :isText="formControlIsText"
      :saveButtonText="saveButtonText"
    )
</template>

<script>
import WtTitle from "@@/WtTitle/WtTitle";
import WtTooltip from "@@/WtTooltip/WtTooltip";
import ProgramSettingsFormControls from "@@/ProgramSettingsAdmin/ProgramSettingsFormControls";

export default {
  name: "ProgramSettingsFormWrapper",

  components: { WtTooltip, ProgramSettingsFormControls, WtTitle },

  props: {
    settingType: {
      type: String,
      default: null
    },

    formKey: {
      type: String,
      default: null
    },

    formData: {
      type: [Object, FormData],
      required: true
    },

    disableSave: {
      type: Boolean,
      default: true
    },

    keysToReset: {
      type: Array,
      required: true
    },

    title: {
      type: String,
      default: "Form Title"
    },

    showControls: {
      type: Boolean,
      default: true
    },

    tooltipText: {
      type: String,
      default: ""
    },

    disableReset: {
      type: Boolean,
      default: false
    },

    formControlIsText: {
      type: Boolean,
      default: true
    },

    saveButtonText: {
      type: String,
      default: "SAVE"
    }
  },

  data() {
    return {
      error: false,
      errorMessage: null
    };
  },

  methods: {
    handleFormError(message) {
      this.errorMessage = message;
      this.error = true;
    }
  }
};
</script>

<style lang="sass" scoped>
.program-settings-form-wrapper
  height: 100%
</style>
